import {
    BALANCE_REQUEST_START,
    BALANCE_REQUEST_SUCCESS,
    BALANCE_REQUEST_ERROR,
} from 'state/actions/balance'
import { C2W_EVENT_TYPES } from '@wotfe/client2web'

export const WALLET_STATUS = {
    SYNCING: 'syncing',
    NOT_AVAILABLE: 'not_available',
    AVAILABLE: 'available',
}

export const initialState = {
    gold: 0,
    credits: 0,
    crystal: 0,
    walletStatus: {
        gold: '',
        credits: '',
        crystal: '',
    },
    isWGMoneyAvailable: false,
    errorMessage: null,
    isLoading: false,
    loaded: false,
}

const isWalletsAvailable = walletStatus => (
    Object.values(walletStatus).every(status => status === WALLET_STATUS.AVAILABLE)
)

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case BALANCE_REQUEST_START: {
        return {
            ...state,
            isLoading: true,
        }
    }
    case BALANCE_REQUEST_SUCCESS: {
        const {
            walletStatus,
            gold,
            credits,
            crystal,
        } = action.payload

        return {
            ...state,
            isLoading: false,
            loaded: true,
            isWGMoneyAvailable: isWalletsAvailable(walletStatus),
            walletStatus,
            gold,
            credits,
            crystal,
        }
    }
    case BALANCE_REQUEST_ERROR: {
        return {
            ...state,
            loaded: true,
            isLoading: false,
            errorMessage: action.payload.errorMessage,
            isWGMoneyAvailable: false,
        }
    }
    case C2W_EVENT_TYPES.UPDATE_BALANCE: {
        const { gold, credits, crystal } = action.data
        return {
            ...state,
            gold,
            credits,
            crystal,
        }
    }
    case C2W_EVENT_TYPES.WALLET_UPDATE: {
        return {
            ...state,
            walletStatus: action.data,
            isWGMoneyAvailable: isWalletsAvailable(action.data),
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/balance.js